module.exports = __webpack_public_path__ + "img/img18.24ad88c3.png";